export enum CertificateEvents {
  certificateButton = 'click_button_certificate',
  certificateDownloadButton = 'click_button_download_certificate',
  certificateSuccess = 'pop_up_activate_download_certificate_success',
  certificateError = 'pop_up_activate_download_certificate_error',
}
